"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 * A helper class to help manage drag and drop to an HTML element
 */
var DragAndDropHelper = /** @class */ (function () {
    /**
     * Create a new instance of DragAndDropHelper class
     * @param trigger The trigger element. When user start drag on this element,
     * events will be fired to the handler object
     * @param context Context object that will be passed to handler function when event is fired,
     * so that the handler object knows which element it is triggered from.
     * @param onSubmit A callback that will be invoked when event handler in handler object returns true
     * @param handler The event handler object, see DragAndDropHandler interface for more information
     */
    function DragAndDropHelper(trigger, context, onSubmit, handler) {
        var _this = this;
        this.trigger = trigger;
        this.context = context;
        this.onSubmit = onSubmit;
        this.handler = handler;
        this.onMouseDown = function (e) {
            var _a, _b;
            e.preventDefault();
            e.stopPropagation();
            _this.addDocumentEvents();
            _this.initX = e.pageX;
            _this.initY = e.pageY;
            _this.initValue = (_b = (_a = _this.handler).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, _this.context, e);
        };
        this.onMouseMove = function (e) {
            var _a, _b, _c;
            e.preventDefault();
            var deltaX = e.pageX - _this.initX;
            var deltaY = e.pageY - _this.initY;
            if ((_b = (_a = _this.handler).onDragging) === null || _b === void 0 ? void 0 : _b.call(_a, _this.context, e, _this.initValue, deltaX, deltaY)) {
                (_c = _this.onSubmit) === null || _c === void 0 ? void 0 : _c.call(_this, _this.context);
            }
        };
        this.onMouseUp = function (e) {
            var _a, _b, _c;
            e.preventDefault();
            _this.removeDocumentEvents();
            if ((_b = (_a = _this.handler).onDragEnd) === null || _b === void 0 ? void 0 : _b.call(_a, _this.context, e, _this.initValue)) {
                (_c = _this.onSubmit) === null || _c === void 0 ? void 0 : _c.call(_this, _this.context);
            }
        };
        trigger.addEventListener('mousedown', this.onMouseDown);
    }
    /**
     * Dispose this object, remove all event listeners that has been attached
     */
    DragAndDropHelper.prototype.dispose = function () {
        this.trigger.removeEventListener('mousedown', this.onMouseDown);
        this.removeDocumentEvents();
    };
    DragAndDropHelper.prototype.addDocumentEvents = function () {
        var doc = this.trigger.ownerDocument;
        doc.addEventListener('mousemove', this.onMouseMove, true /*useCapture*/);
        doc.addEventListener('mouseup', this.onMouseUp, true /*useCapture*/);
    };
    DragAndDropHelper.prototype.removeDocumentEvents = function () {
        var doc = this.trigger.ownerDocument;
        doc.removeEventListener('mousemove', this.onMouseMove, true /*useCapture*/);
        doc.removeEventListener('mouseup', this.onMouseUp, true /*useCapture*/);
    };
    return DragAndDropHelper;
}());
exports.default = DragAndDropHelper;
//# sourceMappingURL=DragAndDropHelper.js.map